customElements.define(
  'product-recommendations',
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      this.setIntersectionObserver();
    }

    /**
     * Sets the intersection observer events.
     */
    setIntersectionObserver() {
      this.observer = new IntersectionObserver((entries) => this.handleIntersection(entries));

      this.observer.observe(this);
    }

    /**
     * Handles the section intersection event.
     * @param {Array} entries - The event entries.
     */
    handleIntersection(entries) {
      const { isIntersecting } = entries[0];

      if (!isIntersecting) {
        return;
      }

      this.observer.disconnect();

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((response) => {
          const html = new DOMParser().parseFromString(response, 'text/html');
          const main = html.querySelector('product-recommendations');

          replaceElement(this, main, '[js-product-recommendations="container"]');
          setAllDynamicImages(main);
        });
    }
  }
);
